<template>
    <div>
        <!-- Actions when room is free or soon occupied -->
        <div v-show="occupationStatus !== 'occupied' && !networkError">
            <!-- Book Now Button -->
            <div class="flex justify-center">
                <div
                    v-show="!loading"
                    @click="$emit('book-now')"
                    class="text-4xl w-80 text-white mt-8 text-center py-6 rounded-full cursor-pointer"
                    :class="buttonClasses"
                >
                    Jetzt buchen
                </div>
            </div>

            <!-- Helper Text for Free Status -->
            <div
                v-show="occupationStatus === 'free'"
                class="text-white text-xl flex justify-center mt-6"
            >
                Nächste 30 Minuten buchen
            </div>

            <!-- Soon Occupied Status Details -->
            <div
                v-if="nextBooking && occupationStatus === 'soonOccupied'"
                class="mt-6"
            >
                <div class="text-yellow-400 text-xl flex justify-center">
                    In nächster Zeit reserviert
                </div>
                <p class="text-white text-3xl flex justify-center">
                    {{ extractTime(nextBooking.start) }} -
                    {{ extractTime(nextBooking.end) }}
                </p>

                <!-- Check-in Button -->
                <div
                    v-if="canCheckIn"
                    class="flex justify-center"
                >
                    <div
                        v-show="!loading"
                        @click="$emit('check-in')"
                        class="text-2xl underline text-room-green cursor-pointer"
                    >
                        Einchecken
                    </div>
                </div>
            </div>

            <loading v-show="loading" :is_white="true"></loading>
        </div>

        <!-- Actions when room is occupied -->
        <div v-show="occupationStatus === 'occupied' && !networkError">
            <!-- Check-in Button -->
            <div
                v-if="canCheckIn"
                class="flex justify-center"
            >
                <div
                    v-show="!loading"
                    @click="$emit('check-in')"
                    class="text-4xl w-80 text-white mt-8 text-center py-6 rounded-full cursor-pointer bg-room-green"
                >
                    Einchecken
                </div>
            </div>

            <loading v-show="loading" :is_white="true"></loading>

            <div class="flex justify-center" v-if="!canCheckIn">
                <panel-confirm-dialog @confirmed="$emit('release-room')" class="mr-2">
                    <template v-slot:header>Raum freigeben</template>
                    <template v-slot:question>
                        Soll der Raum wirklich freigegeben werden? Nach der Freigabe können andere Personen
                        den Raum wieder buchen.
                    </template>
                    <template v-slot:confirm>
                        Raum freigeben
                    </template>

                    <div
                        v-show="!loading"
                        class="text-4xl w-80 text-white mt-8 text-center py-6 rounded-full cursor-pointer bg-red-500"
                    >
                        Raum freigeben
                    </div>
                </panel-confirm-dialog>
            </div>
        </div>
    </div>
</template>

<script>
import Loading from "../UI/Loading";
import PanelConfirmDialog from "../UI/PanelConfirmDialog.vue";
import {extractTime} from "../../utils/conferenceRoomTime";

export default {
    name: "RoomBookingActions",

    components: {
        Loading,
        PanelConfirmDialog,
    },

    props: {
        occupationStatus: {
            type: String,
            required: true,
            validator: (value) => ['free', 'occupied', 'soonOccupied'].includes(value),
        },
        nextBooking: {
            type: Object,
            default: null,
        },
        loading: {
            type: Boolean,
            default: false,
        },
        networkError: {
            type: Boolean,
            default: false,
        },
    },

    computed: {
        buttonClasses() {
            return {
                'bg-room-green': this.occupationStatus === 'free',
                'bg-yellow-400': this.occupationStatus === 'soonOccupied',
            };
        },
        canCheckIn() {
            return this.nextBooking &&
                !this.nextBooking.checked_in_at &&
                this.nextBooking.check_in_is_open;
        },
    },

    methods: {
        extractTime,
    },
};
</script>

<style scoped>
/* Flexbox */
.flex {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
}
.justify-center {
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
}

/* Text Colors */
.text-white {
    color: #ffffff;
}
.text-room-green {
    color: #22c55e;
}
.text-yellow-400 {
    color: #facc15;
}

/* Text Size */
.text-4xl {
    font-size: 2.25rem;
    line-height: 2.5rem;
}
.text-3xl {
    font-size: 1.875rem;
    line-height: 2.25rem;
}
.text-2xl {
    font-size: 1.5rem;
    line-height: 2rem;
}
.text-xl {
    font-size: 1.25rem;
    line-height: 1.75rem;
}

/* Text Alignment & Decoration */
.text-center {
    text-align: center;
}
.underline {
    text-decoration: underline;
}

/* Spacing */
.mt-6 {
    margin-top: 1.5rem;
}
.mt-8 {
    margin-top: 2rem;
}
.mr-2 {
    margin-right: 0.5rem;
}
.py-6 {
    padding-top: 1.5rem;
    padding-bottom: 1.5rem;
}

/* Sizing */
.w-80 {
    width: 20rem;
}

/* Background Colors */
.bg-room-green {
    background-color: #22c55e;
}
.bg-yellow-400 {
    background-color: #facc15;
}
.bg-red-500 {
    background-color: #ef4444;
}

/* Border Radius */
.rounded-full {
    -webkit-border-radius: 9999px;
    -moz-border-radius: 9999px;
    border-radius: 9999px;
}

/* Cursor */
.cursor-pointer {
    cursor: pointer;
}
</style>
